import axiosInstance from "../../../axios";

// Create a cache for search results
const searchCache = new Map();



export const search = (searchKeyWord) => async (dispatch) => {
    try {
        // Check cache first
        const cacheKey = searchKeyWord.trim().toLowerCase();
        if (searchCache.has(cacheKey)) {
            return searchCache.get(cacheKey);
        }

        // Create the request payload
        const object = {
            search: searchKeyWord
        };

        // Send search request
        const res = await axiosInstance.post('search', object);

        // Process successful response
        if (res && res.data && res.data.code === 1) {
            const results = res.data.data || [];

            // Cache the results (with a reasonable limit)
            if (searchCache.size > 50) {
                // Remove oldest entry if cache is too large
                const oldestKey = searchCache.keys().next().value;
                searchCache.delete(oldestKey);
            }
            searchCache.set(cacheKey, results);

            return results;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Search error:', error);
        return [];
    }
};

/**
 * Clear the search cache
 */
export const clearSearchCache = () => {
    searchCache.clear();
};

/**
 * Search action for use in search results page
 */
export const fetchSearchResults = (query) => async (dispatch) => {
    dispatch({ type: 'SEARCH_REQUEST', payload: query });

    try {
        const results = await dispatch(search(query));

        if (results && Array.isArray(results) && results.length > 0) {
            dispatch({
                type: 'SEARCH_SUCCESS',
                payload: {
                    query,
                    results,
                    categories: results.filter(item => item && item.type === 'Category'),
                    subCategories: results.filter(item => item && item.type === 'Sub Category'),
                    products: results.filter(item => item && item.type === 'Product')
                }
            });
            return results;
        } else {
            dispatch({
                type: 'SEARCH_SUCCESS',
                payload: {
                    query,
                    results: [],
                    categories: [],
                    subCategories: [],
                    products: []
                }
            });
            return [];
        }
    } catch (error) {
        dispatch({
            type: 'SEARCH_FAILURE',
            payload: { message: error.message }
        });
        return [];
    }
};